function parseQueryMethodArguments(query, entry) {
  let key = entry;
  let value;
  if (Array.isArray(entry)) {
    [key, value = query[key]] = entry;
  } else {
    value = query[key];
  }
  return {
    query,
    key,
    value
  };
}

export { parseQueryMethodArguments };
